import React, { Component } from "react";
import packageJson from "./../../../package.json";
import "./../../assests/styles/header.css";
import Popover from '@material-ui/core/Popover';
var user = JSON.parse(localStorage.getItem("user"));
console.log(user);

const version = packageJson.version;

export default class Header extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showDropDown: false,
			showFClist: false,
			anchorEl: null,
			fcDetails: {}
		};
		this.handlelogoutClose = this.handlelogoutClose.bind(this);
	}
	render() {
		return (
			<div className="row">
				<div className="col-md-2">{this.logo()}</div>
				<div className="col-md-8" />
				<div className="col-md-2" style={{ textAlign: 'right' }}>
					{this.showDropDownMenu()}
				</div>
			</div>
		);
	}

	logo() {
		return (
			<div className="logoImage">
				<img
					className="showImage"
					src="https://s3-ap-southeast-1.amazonaws.com/images-jt/logo-dark.jpg"
					alt="logo"
				/>
			</div>
		);
	}

	openLogout = placement => event => {
		const { currentTarget } = event;
		this.setState(state => ({
			logoutPopOver: state.placement !== placement || !state.logoutPopOver,
			anchorEl: currentTarget
		}));
	};


	handlelogoutClose() {
		this.setState({ logoutPopOver: false });
	}
	showDropDownMenu() {
		return (
			<div>
				<button
					className="btn-primary"
					type="button"
					onClick={this.openLogout('top-left')}
					style={{ height: '60px', backgroundColor: 'rgb(42, 62, 80)', border: 'none', outline: 'none' }}
				>
					{user.userProfile.displayName}
					<span className="caret" />
				</button>
				<Popover open={this.state.logoutPopOver} anchorEl={this.state.anchorEl} onClose={this.handlelogoutClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }} classes={{ paper: 'noOverflowHidden' }}>
					<div style={{ width: '200px', border: '1px solid #c4c4c4', padding: '10px', textAlign: 'center' }}>
						<div>
							{(user.imageUrl) ?
								<img src={this.state.user.imageUrl} alt="user" style={{ width: '50px', height: '50px', borderRadius: '50%' }} />
								:
								<div className="initial-avtr">{user.userProfile.displayName.charAt(0)}</div>
							}
						</div>
						<div style={{margin: '1em 0'}}>
							<div style={{ fontSize: '16px', fontWeight: '600', wordBreak: 'break-all' }}>{user.userProfile.displayName}</div>
							<div style={{ fontSize: '12px', wordBreak: 'break-all' }}>({user.userProfile.loginId})</div>
						</div>
						<div style={{ fontSize: '12px', wordBreak: 'break-all', marginBottom: '1em' }}> Version: {" " + version} </div>
						<div>
							<button className="btn btn-blue-full" onClick={this.logout.bind(this)}>Logout</button>
						</div>
					</div>
				</Popover>
			</div>
		);
	}
	logout() {
		localStorage.clear();
		window.location.reload();
	}
}



// WEBPACK FOOTER //
// ./src/common/header/header.js